<template>
  <b-modal
    id="modal-ttc-theme"
    centered
    title="Add TTC Theme"
    :no-close-on-backdrop="true"
  >
    <v-select
      v-model="selected"
      v-validate="{ required: true }"
      :options="options"
      label="concepts"
      placeholder="Search TTC Themes"
      data-vv-name="Theme"
      multiple
      @search="debounceSearch"
    ></v-select>

    <template slot="modal-footer">
      <b-btn
        variant="primary"
        class="float-right"
        :disabled="!selected.length"
        @click="addFilters"
        ><i class="fa fa-plus" /> Add to query</b-btn
      >
    </template>
  </b-modal>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";
import { mapActions } from "vuex";

export default {
  name: "ThemeSearchModal",
  components: {
    vSelect
  },
  data() {
    return {
      search: null,
      selected: [],
      options: []
    };
  },
  computed: {
    selectedFormatted() {
      return this.selected.map(
        theme =>
          (theme = {
            id: theme.id,
            title: theme.concepts,
            topic_id: theme.topic_id
          })
      );
    }
  },
  methods: {
    ...mapActions(["searchTTCThemes"]),
    addFilters() {
      this.$emit("addToQuery", "ttc-theme", this.selectedFormatted);
      this.$bvModal.hide("modal-ttc-theme");
      this.selected = [];
    },
    debounceSearch: _.debounce(function(val) {
      this.searchTTCThemes({ query: val }).then(res => {
        this.options = res.map(theme => ({
          id: theme.id,
          topic_id: theme.topic_id,
          concepts: theme.children.map(concept => concept.name).join(", ")
        }));
      });
    }, 400)
  }
};
</script>
